import {Filter} from '../../../core/filter/filter';
import {LocalDate} from '@js-joda/core';

export class PayrollFilter  extends Filter {
  public employeeId?: number;
  public fromDate?: LocalDate;
  public toDate?: LocalDate;
}
